// import types
import type { CopyDutyLine } from 'RestAPIs/employees/hours-table/types';

export const FIELDS_TO_COPY: (keyof CopyDutyLine)[] = [
  'dvb',
  'organizationalUnit',
  'workAgreementNr',
  'dutyCodeGeneral',
  'dutyCodeGeneralOrganizationalUnit',
  'period',
  'dutyTime',
  'calculatedHours',
  'dutyType'
] as const;

export const QUERY_KEY_DUTY_LINES = 'hoursTable:dutyLines';

export const EDITABLE_FIELDS = {
  nominal: new Set(['dvb', 'dutyTime', 'dutyType']),
  other: new Set([
    'dvb',
    'organizationalUnit',
    'displayDutyCode',
    'periods',
    'dutyType'
  ]),
  employeePortalDraft: new Set([
    'dvb',
    'organizationalUnit',
    'displayDutyCode',
    'periods',
    'dutyType'
  ]),
  employeePortalExisting: new Set(['periods', 'dutyType'])
};
